import React from "react";
import { useSelector } from "react-redux";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ButtonCounter } from "../../components/ButtonCounter/ButtonCounter";

export default function CreatorResultsCounter({ endOfList }) {
  const searchAudienceResult = useSelector(
    (state) => state.creatorSearchReducer.searchAudienceResult,
  );
  const searchAudienceInfo = useSelector(
    (state) => state.creatorSearchReducer.searchAudienceInfo,
  );

  const searchResultsWithoutDuplicates = searchAudienceResult.reduce(
    (accumulator, currentValue) => {
      if (!accumulator.find((item) => currentValue.userId === item.userId)) {
        accumulator.push(currentValue);
      }
      return accumulator;
    },
    [],
  );

  const getNumberOfResults = () => {
    let numOfResults;
    if (endOfList) {
      numOfResults = searchResultsWithoutDuplicates.length;
    } else {
      if (searchAudienceInfo?.totalResults >= 10000) {
        numOfResults = "9999+";
      } else {
        numOfResults = searchAudienceInfo?.totalResults;
      }
    }
    return numOfResults;
  };
  const numberOfResults = getNumberOfResults();
  return (
    <div className="results-table-counter">
      <ButtonCounter
        borderRadius="6px"
        count={numberOfResults}
        color="#45485B"
        backgroundColor="#EDEDEF"
      />{" "}
      <IDHFormattedMessage id="front_results" defaultMessage="results" />
    </div>
  );
}
